class MobileStickyBuyButtons extends HTMLElement {
  constructor() {
    super();
    this.productForm = null;
    this.stickyElement = null;
    this.originalButtons = null;
    this.observer = null;
    this.isSticky = false;
    this.isUpdatingPrice = false;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    // Only initialize on mobile
    if (window.innerWidth > 767) return;

    this.productForm = this.closest('.product-form');
    if (!this.productForm) return;

    this.originalButtons = this.productForm.querySelector('.product-form__buttons.product-details-add-to-cart');
    if (!this.originalButtons) return;

    this.createStickyElement();
    this.setupEventListeners();
    this.enableBodyClass();
    this.setupPriceObserver();
    
    // Always show sticky bar when feature is enabled
    this.showStickyElement();
  }

  createStickyElement() {
    // Create sticky element
    this.stickyElement = document.createElement('div');
    this.stickyElement.className = 'mobile-sticky-buy-buttons';
    this.stickyElement.innerHTML = `
      <div class="mobile-sticky-buy-buttons__inner">
        <div class="mobile-sticky-buy-buttons__product-info">
          <div class="mobile-sticky-buy-buttons__product-price"></div>
        </div>
        <div class="mobile-sticky-buy-buttons__form">
          ${this.createStickyForm()}
        </div>
      </div>
    `;

    document.body.appendChild(this.stickyElement);
    
    // Update price after creating the element
    this.updatePrice();
  }

  updatePrice() {
    if (!this.stickyElement || this.isUpdatingPrice) return;
    
    this.isUpdatingPrice = true;
    let productPrice = '';
    
    // Strategy 1: Look for elements with price-related classes
    const priceElements = document.querySelectorAll(`
      .price, .product__price, .money, 
      [class*="price"], [class*="cost"], [class*="amount"],
      .price__regular, .price__sale, .price__current
    `);
    
    // Try to find price from these elements
    for (const element of priceElements) {
      const text = element.textContent.trim();
      const html = element.innerHTML.trim();
      
      // Check if this looks like a price (including Turkish Lira and various formats)
      const pricePatterns = [
        /[\$€£¥₹₽¢]\s*[\d,.]+/,           // $99.99, €99,99
        /[\d,.]+\s*[\$€£¥₹₽¢]/,           // 99.99$
        /[\d,.]+\s*TL/i,                  // 21.900 TL (Turkish Lira)
        /TL\s*[\d,.]+/i,                  // TL 21.900
        /[\d,.]+\s*(USD|EUR|GBP|TRY)/i,   // 99.99 USD, 21900 TRY
      ];
      
      let foundPrice = false;
      for (const pattern of pricePatterns) {
                 if (text && pattern.test(text) && text.length < 50) {
           productPrice = html;
           foundPrice = true;
           break;
         }
      }
      
      if (foundPrice) break;
    }
    
    // Strategy 2: If still no price, look for any element containing currency
    if (!productPrice) {
      const allElements = document.querySelectorAll('span, div, p, strong, b, em');
      for (const element of allElements) {
        const text = element.textContent.trim();
        
        // Skip if element is inside our sticky bar
        if (element.closest('.mobile-sticky-buy-buttons')) continue;
        
        // Look for currency patterns including Turkish Lira
        const currencyPatterns = [
          /[\$€£¥₹₽¢]\s*[\d,.]+/,
          /[\d,.]+\s*[\$€£¥₹₽¢]/,
          /[\d,.]+\s*TL/i,
          /TL\s*[\d,.]+/i
        ];
        
        let foundInGeneral = false;
                  for (const pattern of currencyPatterns) {
            if (text && text.length < 50 && pattern.test(text)) {
              productPrice = element.innerHTML;
              foundInGeneral = true;
              break;
            }
          }
        
        if (foundInGeneral) break;
      }
    }
    
    // Strategy 3: Look specifically in product form area
    if (!productPrice && this.productForm) {
      const productContainer = this.productForm.closest('.product, .product-info, main');
      if (productContainer) {
        const formElements = productContainer.querySelectorAll('*');
        for (const element of formElements) {
          const text = element.textContent.trim();
          if (element.closest('.mobile-sticky-buy-buttons')) continue;
          
          // Check for various currency patterns including Turkish Lira
          const formPatterns = [
            /[\$€£¥₹₽¢]\s*[\d,.]+/,
            /[\d,.]+\s*[\$€£¥₹₽¢]/,
            /[\d,.]+\s*TL/i,
            /TL\s*[\d,.]+/i
          ];
          
                      for (const pattern of formPatterns) {
              if (text && text.length < 30 && pattern.test(text)) {
                productPrice = element.innerHTML;
                break;
              }
            }
          
          if (productPrice) break;
        }
      }
    }
    
    // Strategy 4: Last resort - look for any text that looks like money
    if (!productPrice) {
      const allTextElements = document.querySelectorAll('*');
      
      for (const element of allTextElements) {
        if (element.closest('.mobile-sticky-buy-buttons')) continue;
        
        const text = element.textContent?.trim() || '';
        
        // Look for various price patterns including Turkish formats
        const pricePatterns = [
          /\$\s*\d+(?:[,.]?\d{3})*(?:\.\d{2})?/,     // $99.99, $1,299.00
          /\d+(?:[,.]?\d{3})*(?:\.\d{2})?\s*\$/,     // 99.99$
          /€\s*\d+(?:[,.]?\d{3})*(?:\.\d{2})?/,      // €99.99
          /£\s*\d+(?:[,.]?\d{3})*(?:\.\d{2})?/,      // £99.99
          /\d+(?:[,.]?\d{3})*(?:\.\d{2})?\s*EUR/,    // 99.99 EUR
          /\d+(?:[,.]?\d{3})*(?:\.\d{2})?\s*USD/,    // 99.99 USD
          /\d+(?:\.\d{3})*(?:,\d{2})?\s*TL/i,        // 21.900 TL (Turkish format)
          /TL\s*\d+(?:\.\d{3})*(?:,\d{2})?/i,        // TL 21.900
          /\d+(?:[,.]?\d{3})*\s*TRY/i                // 21900 TRY
        ];
        
                  for (const pattern of pricePatterns) {
            if (pattern.test(text) && text.length < 20) {
              productPrice = element.innerHTML;
              break;
            }
          }
        
        if (productPrice) break;
      }
    }
    
    // Update the price in sticky element
    const priceContainer = this.stickyElement.querySelector('.mobile-sticky-buy-buttons__product-price');
    if (priceContainer) {
      priceContainer.innerHTML = productPrice || '💰 No price detected';
    }
    
    this.isUpdatingPrice = false;
  }

  createStickyForm() {
    const originalForm = this.originalButtons.closest('form');
    if (!originalForm) return '';

    const quantityInput = this.originalButtons.querySelector('.quantity');
    const submitButton = this.originalButtons.querySelector('.product-form__submit');
    const variantSelect = this.productForm.querySelector('select[name="id"], variant-selects select');

    let formContent = '';

    // Add variant selector if exists and has multiple options
    if (variantSelect && variantSelect.options.length > 1) {
      formContent += `
        <div class="select">
          <select name="id" class="mobile-sticky-variant-select form-control">
            ${Array.from(variantSelect.options).map(option => 
              `<option value="${option.value}" ${option.selected ? 'selected' : ''}>${option.text}</option>`
            ).join('')}
          </select>
          <svg class="icon icon-caret-down" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 1L5 5L1 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      `;
    }

    // Add quantity selector if exists
    if (quantityInput) {
      const qtyInput = quantityInput.querySelector('input[name="quantity"]');
      if (qtyInput) {
        formContent += `
          <div class="quantity">
            <button class="quantity__button" name="minus" type="button">
              <svg class="icon icon-minus" viewBox="0 0 10 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1H9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <input class="quantity__input" type="number" name="quantity" value="${qtyInput.value}" min="${qtyInput.min}" max="${qtyInput.max || ''}" step="${qtyInput.step}" />
            <button class="quantity__button" name="plus" type="button">
              <svg class="icon icon-plus" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 1V9M1 5H9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        `;
      }
    }

    // Add submit button
    if (submitButton) {
      const buttonClass = submitButton.className;
      const buttonText = submitButton.querySelector('.btn__text, span')?.textContent || 'Add to Cart';
      const isDisabled = submitButton.disabled;
      
      formContent += `
        <button type="submit" name="add" class="${buttonClass}" ${isDisabled ? 'disabled' : ''}>
          <span class="btn__text">${buttonText}</span>
          <div class="loading-overlay__spinner hidden">
            <svg class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
              <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
            </svg>
          </div>
        </button>
      `;
    }

    return formContent;
  }



  setupEventListeners() {
    if (!this.stickyElement) return;

    // Handle form submission
    const stickyForm = this.stickyElement.querySelector('.mobile-sticky-buy-buttons__form');
    if (stickyForm) {
      stickyForm.addEventListener('click', (e) => {
        if (e.target.type === 'submit' || e.target.closest('button[type="submit"]')) {
          e.preventDefault();
          this.handleFormSubmission();
        }
      });

      // Handle quantity buttons
      stickyForm.addEventListener('click', (e) => {
        if (e.target.classList.contains('quantity__button') || e.target.closest('.quantity__button')) {
          const button = e.target.closest('.quantity__button');
          const input = button.parentElement.querySelector('.quantity__input');
          const isIncrement = button.name === 'plus';
          
          let newValue = parseInt(input.value) + (isIncrement ? 1 : -1);
          newValue = Math.max(parseInt(input.min) || 1, newValue);
          if (input.max) newValue = Math.min(parseInt(input.max), newValue);
          
          input.value = newValue;
          this.syncQuantityWithOriginal(newValue);
        }
      });

      // Handle variant change
      const variantSelect = stickyForm.querySelector('.mobile-sticky-variant-select');
      if (variantSelect) {
        variantSelect.addEventListener('change', (e) => {
          this.syncVariantWithOriginal(e.target.value);
        });
      }
    }

    // Handle resize
    window.addEventListener('resize', () => {
      if (window.innerWidth > 767) {
        this.destroy();
      }
    });
  }

  handleFormSubmission() {
    const originalSubmitButton = this.originalButtons.querySelector('.product-form__submit');
    if (originalSubmitButton) {
      // Update original form with sticky values
      this.syncAllValuesWithOriginal();
      
      // Trigger original form submission
      originalSubmitButton.click();
    }
  }

  syncQuantityWithOriginal(value) {
    const originalQuantityInput = this.originalButtons.querySelector('input[name="quantity"]');
    if (originalQuantityInput) {
      originalQuantityInput.value = value;
      originalQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  syncVariantWithOriginal(value) {
    const originalVariantSelect = this.productForm.querySelector('select[name="id"]');
    if (originalVariantSelect) {
      originalVariantSelect.value = value;
      originalVariantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      
      // Update price after variant change with a small delay
      setTimeout(() => {
        this.updatePrice();
      }, 100);
    }
  }

  syncAllValuesWithOriginal() {
    const stickyQuantity = this.stickyElement.querySelector('input[name="quantity"]');
    const stickyVariant = this.stickyElement.querySelector('select[name="id"]');
    
    if (stickyQuantity) {
      this.syncQuantityWithOriginal(stickyQuantity.value);
    }
    
    if (stickyVariant) {
      this.syncVariantWithOriginal(stickyVariant.value);
    }
  }

  showStickyElement() {
    if (!this.stickyElement || this.isSticky) return;
    
    this.stickyElement.classList.add('show');
    this.isSticky = true;
    
    // Update price when showing the sticky element
    this.updatePrice();
  }

  hideStickyElement() {
    if (!this.stickyElement || !this.isSticky) return;
    
    this.stickyElement.classList.remove('show');
    this.isSticky = false;
  }

  enableBodyClass() {
    document.body.classList.add('mobile-sticky-buy-enabled');
  }

  setupPriceObserver() {
    // Watch for price changes only in the main product area, not in our sticky element
    const productArea = document.querySelector('.product, .product-info');
    if (productArea) {
      const priceObserver = new MutationObserver((mutations) => {
        let shouldUpdate = false;
        
        mutations.forEach((mutation) => {
          // Skip if the mutation is in our sticky element (prevent infinite loop)
          if (mutation.target.closest('.mobile-sticky-buy-buttons')) {
            return;
          }
          
          if (mutation.type === 'childList' || mutation.type === 'characterData') {
            // Check if the mutation affects price elements
            const target = mutation.target;
            if (target.classList && (target.classList.contains('price') || 
                target.closest('.price') || 
                target.classList.contains('money'))) {
              shouldUpdate = true;
            }
          }
        });
        
        if (shouldUpdate) {
          setTimeout(() => this.updatePrice(), 100);
        }
      });

      priceObserver.observe(productArea, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }

  destroy() {
    if (this.stickyElement) {
      this.stickyElement.remove();
    }
    
    document.body.classList.remove('mobile-sticky-buy-enabled');
  }
}

customElements.define('mobile-sticky-buy-buttons', MobileStickyBuyButtons);

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  const productForms = document.querySelectorAll('.product-form--with-mobile-sticky');
  productForms.forEach(form => {
    if (!form.querySelector('mobile-sticky-buy-buttons')) {
      const stickyElement = document.createElement('mobile-sticky-buy-buttons');
      form.appendChild(stickyElement);
    }
  });
}); 